import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [],
  count: 0,
  loading: false,
  error: null,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setWishlist: (state, action) => {
      state.items = action.payload.data || [];
      state.count = action.payload.data?.length || 0;
      state.loading = false;
      state.error = null;
    },

    setWishlistCount: (state, action) => {
      state.count = action.payload;
    },

    addItem: (state, action) => {
      const exists = state.items.find(item => item.product_id === action.payload.product_id);
      if (!exists) {
        state.items.push(action.payload);
        state.count = state.items.length;
      }
    },

    removeItem: (state, action) => {
      state.items = state.items.filter(item => item.product_id !== action.payload);
      state.count = state.items.length;
    },

    clearWishlist: (state) => {
      state.items = [];
      state.count = 0;
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setWishlist,
  setWishlistCount,
  addItem,
  removeItem,
  clearWishlist,
  setLoading,
  setError,
} = wishlistSlice.actions;

// Selectors
export const selectWishlist = (state) => state.wishlist;
export const selectWishlistItems = (state) => state.wishlist.items;
export const selectWishlistCount = (state) => state.wishlist.count;
export const selectIsInWishlist = (productId) => (state) => 
  state.wishlist.items.some(item => item.product_id === productId);

export default wishlistSlice.reducer;